import Vue from 'vue';
import Component from 'vue-class-component';
import { User } from '@/core/models/user.model';
import { MEETINGS_ACTION } from '@/content/actions/meeting.actions';
import { Meeting } from '@/content/models/meeting.model';
import { EVENT_BUS } from '@/content/values/events';
import { Prop, Watch } from 'vue-property-decorator';
import { STORE } from '@/core/store/core.store';
import { MEETING_EVENTS } from '@/meetings/values/meetings.values'

@Component({})
export default class EdMeetingDetails extends Vue {

  /* Props */
  @Prop() readonly meetingId: any;

  /* Variables */
  public isLoadingMembers: boolean = false;
  public alreadyLoadedOnce:boolean = false;

  /* Computed */
  get meeting(): any { 
    let meeting = this.$store.state.TeacherPortalStore.meetings.find((m: Meeting) => { return (m.meetingId == Number(this.meetingId)) });
    if(!meeting) {
      this.$edEventBus.$emit(EVENT_BUS.GO_TO_DASHBOARD);
      return;
    }
    return meeting; 
  }

  get members(): User[] {
    if(this.meeting) {
      if(this.meeting.members.length == 0 && this.alreadyLoadedOnce == false) {
        this.alreadyLoadedOnce = true;
        this.getMeetingMembers();
      }
    }
    return this.meeting ? this.meeting.members : [];
  }

  /* Methods */
  getMeetingMembers() {
    this.isLoadingMembers = true;
    this.$store.dispatch(`${STORE.TEACHER_PORTAL.NAME}/${MEETINGS_ACTION.GET_MEMBERS_MEETING}`, this.meeting).finally(() => {
      this.isLoadingMembers = false;
    });
  }

  /* Hooks */
  created(){
    this.$edEventBus.$on(MEETING_EVENTS.GET_MEETING_MEMBERS,()=>this.getMeetingMembers());
  }

  /* Watcher */
  @Watch('meetingId')
  inputChanged(meetingId:any){
    this.alreadyLoadedOnce = false;
  }
}